module.exports = __webpack_public_path__ + "img/user.297f9562.png";